import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    longerLoansOfferTypeHeading: {
        id: '_.offer_type_select.longer_loans_offer_type_heading',
        defaultMessage: 'I want my offer terms to be'
    },
    interstOnlyOfferTypeHeading: {
        id: '_.offer_type_select.interest_only_offer_type_heading',
        defaultMessage: 'I want my offer terms to be'
    },
    flexibleLoansTitle: {
        id: '_.offer_type_select.flexi_loans_title',
        defaultMessage:
            '<strong>Flexible Loans:</strong> repay early from day 1'
    },
    flexibleLoansTitle_withIOoption: {
        id: '_.offer_type_select.flexi_loans_title_with_interest_only',
        defaultMessage:
            '<strong>Flexible Loans</strong>:repay any time, no early repayment fees'
    },
    interestOnlyLoansTitle: {
        id: '_.offer_type_select.interest_only_loans_title',
        defaultMessage:
            '<strong>Interest Only:</strong> pay only interest for the first 3 months'
    },
    longerLoansTitle: {
        id: '_.offer_type_select.longer_loans_title',
        defaultMessage:
            '<strong>Longer Durations:</strong> smaller monthly repayments'
    }
});
